import React from 'react';
import { NextSeo } from 'next-seo';
import { useUserAgent } from 'next-useragent';
import nookies from 'nookies';
import { RootStoreProvider } from '../providers/RootStoreProvider';
import { Layout } from '../components/Layout';
import { ShipsPage } from '../components/ShipsPage';
import { BreadCrumbs } from '../components/BreadCrumbs';
import { Collapsed } from '../components/Collapsed';
import { Text } from '../components/Text';
import { apiProxy } from '../lib/api';
import styles from '../styles/shipsPage.module.sass';
import { SearchStoreProvider } from '../providers/SearchStoreProvider';
import { logger } from '../lib/logger';
import { containsSea } from '../utils/containSea';

export default function ResultPage({
  uaString,
  store: { user, popularPopdirs },
  canonicalUrl,
}) {
  const ua = useUserAgent(uaString || window.navigator.userAgent);
  const { isMobile, isTablet } = ua;
  const pageRoute = [{ title: 'Поиск теплоходов', link: '/ships' }];

  const items = [
    {
      title: 'Бескрайние просторы: открываем мир речных круизов',
      body: (
        <div>
          <Text component="p" pabottomGap="12">
            Круизы с каждым годом пользуются все большим спросом. Очевидное
            преимущество – посещение разнообразных локаций на пути следования.
            Путешественники могут увидеть старинные города, памятники
            архитектуры, музеи, галереи и театры. И все это без многочисленных
            перелетов и переездов.
          </Text>
          <Text component="p" pabottomGap="12">
            Вот лишь несколько причин отправиться в путешествие на круизном
            лайнере:
          </Text>
          <ul>
            <li>можно увидеть много стран за одну поездку;</li>
            <li>путешествие проходит в комфорте;</li>
            <li>на борту доступна масса развлечений на любой вкус.</li>
          </ul>
        </div>
      ),
    },
    {
      title: 'Какие бывают классы теплоходов?',
      body: (
        <div>
          <Text component="p" pabottomGap="12">
            Чтобы вам было удобнее, мы разделили все теплоходы на пять классов.
            Какое бы судно вы ни выбрали, исходя из его категории, рейтинга и
            других характеристик, оно может подарить вам незабываемый отдых.
          </Text>
          <ul>
            <li>
              <strong className={styles.faqList}>Премиум.</strong>{' '}
              <Text className={styles.faqList} component="p">
                На таких больших теплоходах предусмотрены не просто каюты, а
                полноценные номера с панорамными окнами и всем необходимым для
                прекрасного путешествия. Вам каждый день будут открываться новые
                захватывающие виды. Также на борту есть бассейн, рестораны,
                бары, спортивные залы и массажные салоны, бильярд и многое
                другое для комфортного отдыха класса премиум. Вы уже отдыхали на
                четырехпалубном судне? Сейчас самое время!
              </Text>
            </li>
            <li>
              <strong className={styles.faqList}>Люкс.</strong>{' '}
              <Text className={styles.faqList} component="p">
                {' '}
                Путешественников ждет прекрасный отдых на комфортабельных
                теплоходах, живописные берега, дизайнерские интерьеры и
                увлекательные экскурсии. Что же еще? Авторская кухня, большой
                выбор напитков, разнообразные развлечения на борту и хороший
                сервис.
              </Text>
            </li>
            <li>
              <strong className={styles.faqList}>Комфорт.</strong>{' '}
              <Text className={styles.faqList} component="p">
                Прекрасное соотношение цены и качества тура. Широкая география
                маршрутов, различная продолжительность круизов, экскурсионная и
                развлекательная программы на борту – продумано всё! Туристы
                отдыхают душой и телом и получают хороший сервис.
              </Text>
            </li>
            <li>
              <strong className={styles.faqList}>Стандарт.</strong>{' '}
              <Text className={styles.faqList} component="p">
                Предусмотрены современные интерьеры и каюты со всем необходимым.
                Экскурсии и формат питания туристы могут подобрать
                индивидуально. Если многолюдным и активным путешествиям вы
                предпочитаете более спокойные, этот отдых для вас.
              </Text>
            </li>
            <li>
              <strong className={styles.faqList}>Эконом.</strong>{' '}
              <Text className={styles.faqList} component="p">
                Туры обычно проходят на небольших уютных теплоходах, где вы
                можете ощутить атмосферу путешествия. Все речные суда оснащены
                современным навигационным оборудованием и прошли реновацию с
                обновлением интерьеров.
              </Text>
            </li>
          </ul>
          <Text component="p" topGap="12">
            Посмотреть список судов, фото теплоходов, почитать описание речных
            теплоходов, а также купить путевку онлайн на теплоходы из Москвы и
            не только вы можете на нашем сайте. Вас ждет удивительный отдых
            вместе с «Круиз.онлайн»!
          </Text>
        </div>
      ),
    },
  ];
  return (
    <SearchStoreProvider hydrationData={{ user }}>
      <RootStoreProvider hydrationData={{ user }}>
        <NextSeo
          title="Каталог речных теплоходов России на 2025 год – описание, классы теплоходов, расписание круизов"
          description="Речные круизные теплоходы для путешествий по России от эконом до премиум класса. Новые, большие и современные теплоходы для речных круизов из Москвы по рекам страны. Выбирайте комфортное судно для путешествия, ознакомьтесь с ценами и расписанием круизов на 2024 и 2025 год и оформляйте заявку онлайн."
          additionalLinkTags={[
            {
              rel: 'shortcut icon',
              href: '/favicon.ico?v=2',
            },
          ]}
          canonical={canonicalUrl}
        />
        <Layout
          isMobile={isMobile}
          isTablet={isTablet}
          popularPopdirs={popularPopdirs}
        >
          <div className="container--block">
            <div>
              <BreadCrumbs routeCrumbs={pageRoute} />
            </div>
            <ShipsPage isMobile={isMobile} />
            <section
              className={styles.faqSection}
              itemScope
              itemType="https://schema.org/FAQPage"
            >
              <Collapsed items={items} shorter isCruis />
            </section>
          </div>
        </Layout>
      </RootStoreProvider>
    </SearchStoreProvider>
  );
}

export const getServerSideProps = async ctx => {
  const cookies = nookies.get(ctx);
  const { token } = cookies;

  const canonicalUrl = `https://kruiz.online${ctx.req.url}`;
  const hasSea = containsSea(ctx.req.url);
  try {
    const responses = await Promise.allSettled([
      apiProxy.get(`ApiPopdirNew/getHeaderPopdir/${hasSea}`, {
        headers: {
          'x-request-id': ctx.req.headers['x-request-id'] ?? 'qwert',
          ym_uid: cookies._ym_uid || 'ym_cid not found',
        },
      }),
    ]);

    const [popularPopdirs] = responses.map(req =>
      req.status === 'fulfilled' ? req.value.data ?? null : null,
    );
    const user = await apiProxy
      .get(`ApiUsers/check_token/${token ?? ''}`, {
        headers: {
          'x-request-id': ctx.req.headers['x-request-id'] ?? 'qwert',
          ym_uid: cookies._ym_uid || 'ym_cid not found',
        },
      })
      .then(resp => resp.data);
    logger({
      additionalFields: {
        url: ctx.resolvedUrl,
      },
      level: 'debug',
      ym_uid: cookies._ym_uid,
      message: 'ships page has been created',
    });
    return {
      props: {
        store: { user, popularPopdirs },
        uaString: ctx.req.headers['user-agent'],
        canonicalUrl,
      },
    };
  } catch (error) {
    logger({
      additionalFields: {
        url: ctx.resolvedUrl,
      },
      error,
      level: 'error',
      message: 'ships page was not created',
    });
    return {
      redirect: {
        destination: '/503',
        permanent: true,
      },
    };
  }
};
